// const V = '/v1';
const V = "/v2/biz";
const cli = "v2/cli";
const admin = 'v2/admin';
const V3 = "/v3/biz";
const v4 = "/v4/biz";

export default {
  joint_orders:`${V3}/joint_orders`,
  /**核心 */
  get_user: `${V}/user`, //获取用户信息
  userImage: `${V}/users`, //登录头像
  logins: `${V}/login`, //用户登陆
  getCity: `${V}/get_city`, //获取城市，
  getArea: `${V}/get_area`, //获取区域，
  workIndex: `${V}/work_index`, //终端统计
  workIndex_day: `${V}/sales_Index`, //终端统计日
  workIndex_cli: `${V}/cli_Index`, //终端统计销售
  workIndexOne: `${V3}/work_index_one`, //终端统计销售1
  workIndexTow: `${V3}/work_index_tow`, //终端统计销售2
  workLineTree: `${V}/line/tree`, //线路点位数
  getRole: `${V}/get_role`, //获取用户能创建的角色
  getNotice: `${V}/get_notice`, //获取公告
  exContract: `${V}/expiring_contract`, //获取即将过期的合同

  /**活动 */
  getAllActivities: `${V}/getAllActivities`, //活动列表
  deleteActivity: `${V}/deleteActivity`, //删除活动
  addActivity: `${V}/addActivity`, //添加活动
  updateActivity: `${V}/updateActivity`, //更新活动
  getActivityDetail: `${V}/getActivityDetail`, //活动详情
  takeActivityEffective: `${V}/takeActivityEffective`, //活动生效
  takeActivityExpired: `${V}/takeActivityExpired`, //活动下线
  get_all_discount: `${V}/get_all_discount`, //获取所有打折活动
  up_discount: `${V}/up_activity_discount/`, //上线打折活动
  down_discount: `${V}/down_activity_discount/`, // 下线打折活动
  get_activity_discount: `${V}/get_activity_discount/`, //根据ID获取打折活动
  add_activity_discount: `${V}/add_activity_discount`, //添加打折活动
  delete_activity_discount: `${V}/delete_activity_discount/`, //删除打折活动
  update_activity_discount_terminal: `${V}/update_activity_terminal/`, //获取修改时打折活动的柜子
  add_activity_discount_terminal: `${V}/activity_terminal`, //获取添加时打折活动的柜子
  update_activity_discount: `${V}/update_activity_discount`, //修改打折活动,
  get_activity_terminal: `${V}/activity/get_hard_number`, //获取活动内柜子

  /**提现 */
  withdraw: `${V}/withdraw`, //申请提现
  withdraw_select: `${V}/withdraw/select`, //提现下拉
  withdraw_info: `${V}/withdraw/info`, //提现账户数据
  withdraw_cancel: `${V}/withdraw/cancel`, //提现申请取消
  withdrawal_review: `${V}/withdrawal_review`, //提现审核列表
  withdrawal_all_review: `${V}/withdrawal_review_account`, //已提现总金额，可提现总金额
  withdraw_resolve: `${V}/withdrawal_review_audit`, //审核通过
  withdraw_reject: `${V}/withdrawal_review_reject`, //审核驳回
  withdraw_export: `${V}/withdrawal_review_export`, //审核导出

  /**线路&&点位 */
  addLine: `${V}/add_line`, //添加线路，
  findLine: `${V}/find_line`, //获取线路详情，
  updateLine: `${V}/update_line`, //获取线路详情，
  getBypoint: `${V}/get_by_point`, //获取线路编号
  getPoint: `${V}/get_point`, //获取线路编号
  getPointNumber: `${V}/get_point_type_number`, //获取点位类型编号
  getPnumber: `${V}/get_point_number`, //获取点位编号
  getProvice: `${V}/get_province`, //获取点位编号
  AddPoint: `${V}/add_point`, //新增点位
  Delpoint: `${V}/delete_point`, //删除点位
  getPointType: `${V}/get_page_point_type`, //获取点位类型
  DelpointType: `${V}/delete_point_type`, //删除点位类型
  Delline: `${V}/delete_line`, //删除点位类型
  exportPoint: `${V}/export_point`, //导出点位数据
  getPageName: `${V}/get_page_name`, //查询所有线路
  updatePoint: `${V}/update_point`, //修改点位
  updatePointType: `${V}/update_point_type`, //修改点位类型
  updateGetlx: `${V}/get_lx`, //获取点位类型详情
  addPointType: `${V}/add_point_type`, //新增点位类型
  getNumber: `${V}/get_number`, //新增线路编号，
  exportPointType: `${V}/export_pointType`, //导出点位类型，
  exportLine: `${V}/export_line`, //导出线路，

  /**备货 */
  stock_list: `${V}/stock/list`, //备货管理
  stock_batch_add: `${V}/stock/batch`, //批量备货
  stock_detail: `${V}/stock/`, //备货详情(修改PUT)
  stock_good_list: function(params: number) {
    return `${V}/stock/${params}/items`;
  }, //备货新增时根据货柜获取货柜里的商品
  stock_items_replace: `${V3}/terminal/items/replace`, //备货生成单据
  stock_cancel: function(id: number) {
    return `${V}/stock/${id}/cancel`;
  }, //备货取消

  /**补货 */
  inventory_detail: `${V}/inventory_detail/`, //补货详情(put,get)
  inventory_list: `${V}/inventory_list`, //补货记录
  inventory_export: `${V}/inventory/export`, //补货导出

  /**商城 */
  betList: `${V}/beta/list`, //商城列表，
  betListDetail: `${V}/beta`, //商城列表详情，
  betListUpdate: `${V}/beta/update`, //商城列表核销，
  verification: `${V}/verification`, //核销
  beta_export: `${V}/export_terminal_beta`, //商城订单导出

  /**意见反馈 */
  suggestList: `${V}/suggestList`, //意见反馈
  suggestDetail: `${V}/suggest/detail`, //意见反馈详情
  updatesuggest: `${V}/suggest/update`, //意见反馈处理跟新
  suggestDelete: `${V}/suggest/delete`, //意见删除
  exportSuggest: `${V}/suggest/export`, //意见反馈导出，

  /**故障 */
  faultList: `${V}/faultList`, //故障列表
  faultUpdate: `${V}/fault/update`, //故障列表
  faultDetail: `${V}/fault/detail`, //上报故障详情
  faultDelete: `${V}/fault/delete`, //故障删除
  exportFault: `${V}/fault/export`, //故障列表导出，

  /**员工 */
  userList: `${V}/users`, //员工列表
  addUser: `${V}/register`, //员工列表

  /**补货员 */
  // replenishList: `${V}/replenish`, //补货员列表
  replenishList: `${V}/get_replenish`, //补货员列表
  replenishHard: `${V}/company/hard_number`, //获取商家所有货柜
  replenishHardHardNumber: `${V}/company/hard_number`, //获取商家所有货柜
  replenish_delete: `${V}/replenish/delete/`, //删除补货员
  replenish_terminal: `${V}/replenish/hard_number/list`, //货柜的补货员
  replenish_by_line: `${V}/stock/manager`, //线路的补货员

  /**合同 */
  contractList: `${V}/contract`, //合同列表展示
  getContractDetail: `${V}/contract`, //合同详情
  updateContract: `${V}/updateContract`, //合同修改
  updateContractStatus: `${V}/contract/status/`, //合同修改状态
  contract_change_detail: `${V}/contract/change/`, //根据cid获取变更合同信息
  update_change_contract: `${V}/contract/change/status/`, //修改已变更合同

  /**货柜 */
  terminal_line: `${V}/line/select`, //货柜线路
  terminal_list: `${V3}/terminal_list`, //货柜管理列表
  terminal_detail: `${V}/terminal/detail`, //货柜详情
  terminal_types: `${V}/terminal/type/list`, //产品型号
  terminal_items: `${V3}/terminal/items`, //货柜中商品列表
  terminal_export: `${V}/template/export`, //货柜导出
  terminal_items_select: `${V}/terminal/items/select`, //货柜选择商品
  terminal_add: `${V}/terminal/add`, //增加货柜
  terminal_update: `${V}/terminal/update`, //更新货柜
  terminal_delete: `${V}/terminal/delete`, //删除货柜
  terminal_effective: `${V}/effective/immediately`, //货柜立即生效
  hardNumberList: `${V}/hardNumberList`, //获取货柜机器编号列表
  category_tree: `${V}/categoryTree`, //货柜商品类别树
  category_list_by_contract: `${V}/type/select`, //根据合同获取类别
  terminal_type_by_hard_number: `${V}/hardNumberList/`, //根据货柜编号获取产品型号
  terminal_point_by_line: `${V}/point/select`, //根据线路获取点位
  qrcode: `${V}/terminal/qrcode`, //二维码
  statusTrending: `${V}/status/trending`, //货柜温湿度
  shutdown: `${V}/terminal/equipment_shutdown`, //货柜 下线,
  start: `${V}/terminal/equipment_start`, //货柜 上线
  restart: `${V}/restart_terminal`, //货柜 重启
  terminal_video: `${V}/get_video`, //货柜视频
  terminal_video_download: `${V}/download_video`, //货柜视频下载
  terminal_create_video: `${V}/ipc_send_video`, //生成视频和图片
  terminal_picture: `${V}/get_image_urls`, //获取图片
  terminal_unlock: `${V}/forced_opening`, //货柜强制开锁
  sleeve_list: `${V}/vr_item`, //获取腰封列表
  terminal_update_price: `${V}/terminal/items/price`, //货柜只修改价格
  unused_terminal: `${V}/not_used_terminal`, //获取未绑定子账号的柜子`
  distribution_terminal: `${V}/distribution/terminal`, //分配柜子给子账号
  reset_terminal_status: `${V}/reset_terminal_status`, //重置机器状态
  network_strength: `${V}/status/network_strength`, //机器网络曲线图

  /**商品分类 */
  category_list: `${V}/categoryList`, //获取商品分类列表（有分页）
  category_delete: `${V}/deleteCategory`, //删除分类
  category_detail: `${V}/categoryDetail`, //获取分类详情
  category_update: `${V}/updateCategory`, //修改分类
  category_add: `${V}/addCategory`, //新增分类

  /**商品 */
  items_list: `${V}/items`, //商品列表
  items_number: `${V}/itemsNumber`, //商品编号
  items_import: `${admin}/admin_items`, //商品导入库

  /**模板 */
  template_list: `${V}/template/list`, //获取模板列表
  template_detail: `${V}/template/detail`, //获取模板详情
  template_add: `${V}/template/add`, //添加模板
  template_delete: `${V}/template/delete`, //删除模板
  template_update: `${V}/template/update`, //修改模板
  template_check: `${V}/template/check`, //模板检测（重力柜专用）

  template_allocate_terminal: `${V}/template_allocate_terminal/`, //模板分配设备

  /**订单 */
  order_list: `${V3}/order/list`, //订单列表
  //joint_orders: `${V}/joint_orders`, //联合查询
  order_detail: `${V}/order/`, //订单详情
  refund: `${V}/refunds`, //扣款
  pappayapply: `${V}/pappayapply`, //收款
  order_close: `${V}/order/handle/`, //订单处理
  order_export: `${V}/export_order_list`, //订单导出
  order_receipt: `${V}/order_pay/`, // 订单收款
  offline_pay:`${V}/offline_pay`,//线下收款

  /**日志 */
  log_list: `${V}/system/log`, //日志列表
  log_detail: function(id: number) {
    return `${V}/system/log/${id}`;
  },
  log_export: `${V}/system/log/export/excel`, //日志导出
  help_document: `${V}/doc_list`, //帮助文档
  download_document: `${V}/download`, //文档下载



  /**二维码 */
  promotion_list: `${V}/promotion/list`, //二维码列表
  promotion_add: `${V}/promotion/add`, //二维码添加

  /**提货点 */
  goods_point: `${V}/goods_point`, //提货点列表

  /**会员管理 */
  member_list: `${V3}/get_user_list`, //会员列表
  member_detail: `${V}/get_single_user_info`, //会员详情
  member_update_status: `${V}/de_friend`, //会员拉黑或解除
  modify_balance:`${V}/modify_balance`,//修改余额
  user_balance_list:`${V}/user_balance_list`,//余额记录

  /**分析 */
  transaction_analysis: `${V}/analysis/transaction`, //交易分析
  order_pay_analysis: `${V3}/analysis/order/pay`, //订单支付分析
  order_refund_analysis: `${V}/analysis/order/refund`, //退款订单分析
  member_analysis: `${V}/count_user`, //会员分析
  flow_analysis: `${V}/flow_analysis`, //客流分析
  flow_trend_analysis: `${V}/flow_trend_analysis`, //客流趋势图
  member_attr_analysis: `${V3}/attribute_analysis`, //会员属性分析
  goods_analysis: `${V}/goods_analysis`, //商品分析
  re_purchase: `${V3}/re_purchase`, //复购率
  line_analysis: `${V}/line/line_count`, //线路分析
  market_analysis: `${V}/analysis/marketing`, //营销分析
  activity_list: `${V}/activity/list`, //活动列表

  /**交易汇总 */
  transactionTotal: `${V}/transaction_details`, //交易列表
  transactionInfo: `${V}/transaction_info`, //交易列表详情
  transactionExport: `${V}/export_transaction_details`, //交易汇总导出

  /**系统设置 */
  system_setting: `${V}/system_setting`, //系统设置
  /**分账 */
  split_bill_config_list: `${V}/get_all_sharing_conf`, //分账配置列表
  split_bill_config_add: `${V}/add_sharing_conf`, //添加分账配置
  split_bill_config_detail: `${V}/get_sharing_conf/`, // 获取分账配置详情
  split_bill_config_delete: `${V}/delete_sharing_conf`, // 删除分账配置
  split_bill_ready_list: `${V3}/get_all_sharing`, //待分账列表
  split_bill_dialog_detail: `${V}/fz_get_detail`, //获取弹窗内分账金额
  split_bill: `${V}/profitsharingOrder`, //分账
  split_bill_already_list: `${V}/get_ready_sharing`, //获取已分账列表
  split_bill_get_role: `${V}/fz_get_role`, //分账获取角色
  split_bill_get_hard_number: `${V}/fz_get_terminals`, //分账获取柜子编号
  split_bill_get_line: `${V}/fz_get_line`, //分账获取线路
  split_bill_get_point: `${V}/fz_get_point`, //分账获取点位
  /**历史库存 */
  cabinet_history: `${V}/stock/record_get`, //历史库存
  cabinet_history_export: `${V}/history/record/export`, //历史库存导出
  refund_order_items: `${V}/refund_order_items`, //订单退款记录
  /**商品分组 */
  goods_group: `${V}/goods_group/list`, //商品分组列表
  group_lower: `${V}/group_lower_use`, //分组开启/关闭下级使用
  goods_group_detail: `${V}/goods_group`, //商品分组api
  goods_rate: `${V}/goods_group/rate`, //商品识别率
  /**订单2.4.3 */
  order_get_imgs: `${V}/order/image_get/`, // 获取订单中的图片
  order_image_status: `${V}/order/image/status`, //设置图片属性
  /**收款设置*/
  collect_fund_setting: `${V}/collect_fund_setting`,

  /**2.5蒙牛接口*/
  region: `${V}/region/list`, //获取大区接口
  addregion: `${V}/region/add`, //新增大区接口
  updateregion: `${V}/region/update`, //更新大区接口
  deleteregion: `${V}/region/`, //删除大区接口
  bizregion: `${V}/region/`, //获取大区详情接口
  //sub_region/add   /sub_region/update
  area: `${V}/sub_region/list`, //获取区域接口
  addarea: `${V}/sub_region/add`, //新增区域接口
  updatearea: `${V}/sub_region/update`, //修改区域接口
  deletearea: `${V}/sub_region/`, //删除区域接口
  point: `${V}/region_point/list`, //获取点位接口
  addpoint: `${V}/region_point/add`, //新增点位接口
  updatepoint: `${V}/region_point/update`, //修改点位接口
  deletepoint: `${V}/region_point/`, //删除点位接口
  pointdetail: `${V}/region_point/`, //获取点位详情接口
  get_hard_number: `${V}/region_terminal/get_hard_number`, //获取检测机编号
  regionstock: `${V}/region_stock/list`, //库存变化明细表
  stocklist: `${V}/region_terminal_info/list`, //监测柜设备详情
  addterminal: `${V}/region_terminal/add`, //监测柜设备添加
  updateterminal: `${V}/region_terminal/update`, //监测柜设备修改
  terminalType: `${V}/terminal_type/`, //获取设备类型
  terminalDetail: `${V}/region_terminal_detail/`, //获取设备详细信息
  stockdetail: `${V}/region_stock_detail/`, //库存查看
  rowdetail: `${V}/region_row_detail/`, //查看图片
  getwsd: `${V}/region_terminal/get_wsd`, //获取温湿度
  workIndexMonitor: `${V}/work_index_monitor`, //工作台1
  workIndexTime: `${V}/work_index_on_time`, //工作台2
  selectRegion: `${V}/get_select_region_info`, //获取范围选择
  workIndextodo: `${V}/work_index_to_do`, //获取待处理事物
  regiongoods: `${V}/region_goods_detail`, //获取商品明细表
  bizhardnumber: `${V}/get_region_hard_number`, //获取监测柜机器编号
  group: `${V}/region_group_detail`, //分组汇总数据
  analysis: `${V}/region_sale_analysis`, //数据分析
  analysischart: `${V}/region_analysis_chart`, //数据分析2

  /**2.6广告管理*/
  advert_list: `${V}/advert_list`, //广告列表
  add_advert: `${V}/add_advert`, //添加广告
  get_advert: `${V}/get_advert`, //获取广告详情
  update_advert: `${V}/update_advert`, //修改广告
  ad_serving_list: `${V}/ad_serving_list`, //获取投放广告列表
  get_terminal_list: `${V}/get_terminal_list`, //获取设备类型
  terminal_ad_serving: `${V}/terminal_ad_serving`, //添加广告投放
  get_ad_serving: `${V}/get_ad_serving`, //获取投放广告列表
  update_serving: `${V}/update_serving`, //修改投放广告
  advert_to_terminal: `${V}/advert_to_terminal`, //投放广告
  delete_advert: `${V}/delete_advert`, //删除广告
  advert_down: `${V}/advert_down`, //下线广告
  /**2.6获取负责人 */
  get_company_manage: `${V}/get_company_manage`, // 获取负责人
  cancel_order: `${V}/cancel_wx_order/`, // 清理空单
  /**2.6.2 */
  order_report_error: `${cli}/submitError`,
  subsequentCollectionByGooods: `${V}/order_receive`,  //货柜订单 补收商品  
  getSubsequentCollectionGoodList: `${V}/terminal_displays`,
  apply_ad: `${V}/to_review/`, //提交广告审核
  examine: `${V}/examine`, //广告审核
  get_terminal_on_time_image: `${V}/get_terminal_on_time_image`, //获取库存实时图片
  get_stock_info: `${V}/get_stock_info`,//获取凭证
  /**2.6.4 */
  mini_program_setting: `${V}/mini_program_setting`, // 小程序设置 
  screen_setting: `${V}/wechat_subscription_setting`, //屏幕设置
  bad_goods_setting: `${V}/error_goods_setting`, //异物设置
  split_bill_setting: `${V}/sharing_pwd_setting`, //分账密码设置
  /**2.7 */
  inventory_record: `${V}/terminal/sock_inventory_list`, //盘货记录
  inventory_record_detail: `${V}/terminal/sock_inventory_detail`, //盘货详情
  /**2.9 */
  ter_record: `${V3}/terminal_door_record/list`, //开门记录表
  terminal: `${V3}/terminal_door_record_count`, //开门统计表
  goods_statistics: `${V}/goods_statistics/list`, //商品统计表
  goods_statistic:`${V}/goods_statistic`,//商品统计详情
  system_manage: `${V}/system/push_manage`, //商品统计表
  bind:`${V}/bind`,
  vending_login:`${V}/vending_login`,
  milk_login:`${V}/milk_login`,

  /**3.0 */
  goodsalestatic: `${V}/goods_sales_statistics/list`, //开门记录表

  /**3.1 */
  third_terminal_items: `${V}/third_terminal_items`, //商品识别分组新增商品
  goods_group_update: `${V}/update_goods_group`, //商品分组修改
  group_details_goods_update: `${V}/group_details_goods_update`, //商品修改直接修改
  goods_group_add: `${V}/third_goods_group`, //商品分组新增
  admin_balance_list: `${V}/admin_balance_list`, //余额列表
  admin_voucher_total: `${V}/admin_voucher_total`, //凭证数据统计
  admin_voucher_list: `${V}/admin_voucher_list`, //凭证列表
  admin_voucher_save: `${V}/admin_voucher_save`, //上传凭证
  admin_voucher_put: `${V}/admin_voucher_put`, //修改凭证
  admin_voucher_del: `${V}/admin_voucher_del`, //取消凭证
  get_third_lib: `${V}/get_third_lib`, //算法服务器
  recognition_setting: `${V}/recognition_setting`, //动态识别
  third_api_used_list: `${V3}/third_api_used_list`, //接口使用列表
  get_order_video: `${V}/get_order_vider`, //获取购物视频
  new_add_sharing_conf: `${V}/new_add_sharing_conf`, //添加分账
  get_new_sharing_conf: `${V}/get_new_sharing_conf`, //分账详情
  update_sharing_conf: `${V}/update_sharing_conf`, //更改分账配置
  pc_power:`${V}/pc_power`, //PC端权限列表
  apple_power:`${V}/apple_power`, //移动端权限列表
  hierarchy_add_power:`${V}/hierarchy_add_power`, //权限配置 调用
  hierarchy: `${V}/hierarchy`, //分级设置
  hierarchy_save: `${V}/hierarchy_save`, //分级创建
  hierarchy_user: `${V}/hierarchy_user`, //分级显示
  // terminal_apply: `${V}/terminal_apply`, //机器审核
  verify_biz_user: `${V}/verify_biz_user`, //分级用户审核
  terminal_apply_examine: `${V}/terminal_apply_examine`, //机器审核通过/不通过
  load_order_video: `${V}/load_order_video`, //下载视频
  door_record_video: `${V}/door_record_video`, //开门记录视频
  daily_sales_statistics: `${V3}/daily_sales_statistics`, //每日销售额统计表
  sock_inventory_export: `${V}/terminal/sock_inventory_export`, //盘点数据导出
  daily_sales_statisticsv2: `${V}/daily_sales_statistics`, //每日销售额统计表

  // 3.9版本需求
  terminal_net_speed: `${V}/terminal_net_speed`, //网络强度网格
  update_terminal_name: `${V}/update_terminal_name`, //机器名称显示与修改
  terminal_android_log: `${V}/terminal_android_log`, //日志下载

  // 4.0版本需求
  clean_agreement: `${V}/clean_agreement`, //清理支付宝协议
  update_activity_status: `${V}/update_activity_status`, //更改打折活动状态
  
  // 4.1版本需求
  ch_auto_clear: `${V}/ch_auto_clear`, //货柜管理是否自动清理空单
  member_blackmail: `${V}/member_blackmail`, //会员拉黑
  pull_black: `${V}/pull_black`, //货柜订单用户拉黑
  update_users: `${V}/update_users`, //是否推送消息
  user_disable: `${V}/user_disable`, //是否禁用
  move_terminal: `${V}/move_terminal`, //货柜管理移机
  get_users: `${admin}/get_users`, //移机商户
  ch_goods_group: `${V}/ch_goods_group`, //商品分组共享按钮
  copy_goods_group: `${V}/copy_goods_group`, //商品分组复制按钮
  export_goods_record: `${V}/export_goods_record`, //商品分组复制按钮
  role_list: `${V}/role_list`, //角色列表
  role: `${V}/role`, //角色列表详情
  add_role: `${V}/add_role`, //角色列表新增权限
  mt_permissions: `${V}/mt_permissions`, //角色列表权限列表移动端
  permissions: `${V}/permissions`, //角色列表权限列表PC端
  delete_role: `${V}/delete_role`, //角色列表删除
  update_role: `${V}/update_role`, //角色列表修改
  role_disable: `${V}/role_disable`, //角色列表是否禁用
  share_goods_group_list: `${V}/share_goods_group_list`, //商品识别分组商品共享复制
  // 4.3版本
  get_discount_goods: `${V}/get_discount_goods`, //打折管理商品选择
  update_activity_good: `${V}/update_activity_good`, //打折商品信息返回
  add_order_remarks:`${V}/add_order_remarks`, //订单备注
  terminal_volume:`${V}/terminal_volume`, //音量调整
  terminal_temperature:`${V}/terminal_temperature`, //温度调整
  batch_update_terminal:`${V}/batch_update_terminal`, //批量修改温度、音量
  linked_list:`${V}/goods_group/linked_list`, //关联商品
  link:`${V}/goods_group/link`, //关联商品提交确定
  clear_link:`${V}/goods_group/clear_link`, //关联商品清空
  move_contract_terminal:`${V}/move_contract_terminal`, //待运营机器移机
// 4.5
get_login_management:`${V}/get_log_management`, //财务对账、业务对账


//4.7
  /**登陆管理 */
  is_finance:`${V}/export_new_order_list`, //财经
  force_offline:`${V}/force_offline`,//强制下线


  //4.7.1接口优化


  simple_password:`${V}/users/simple/password`,

  //补货商品

  terminal_add_displays:`${V3}/terminal_add_displays`,

  //订单补单

nfc_order_replenish:`${V3}/nfc_order_replenish`,

//点位合作商
point_bind_user_info:`${V3}/point_bind_user_info`,

//点位合作商详情修改
point_bind_user_details:`${V3}/point_bind_user_details`,

//点位商设备列表
point_bind_user_all_terminal:`${V3}/point_bind_user_all_terminal`,

//订单列表
point_bind_user_all_order:`${V3}/point_bind_user_all_order`,

//显示当前点位合作商所有的点位
user_all_point:`${V3}/user_all_point`,

//订单导出
point_bind_user_all_order_export:`${V3}/point_bind_user_all_order_export`,
//nfc外呼
nfc_merchant_call:`${V3}/nfc_merchant_call`,


price_change:`${V}/price_change/`,

product_library:`${v4}/product_library/`,

items_terminal_info:`${V}/items_terminal_info/`,

terminal_exhibition:`${v4}/terminal_exhibition/`,

stock_up_task:`${v4}/stock_up_task/`,

equipment_display:`${v4}/equipment_display/`,

//理货任务状态变更
stock_up_task_state:`${v4}/stock_up_task_state/`,

//理货任务再推送
stock_up_task_update:`${v4}/stock_up_task_update/`,

template_terminal_list:`${V}/template_terminal_list/`,

independent_price_change:`${V}/independent_price_change/`,

unpaid_order_export:`${V3}/unpaid_order_export/`,

//库存恢复
inventory_transfer:`${v4}/inventory_transfer/`,







};
